import PropTypes from "prop-types";
import React from "react";
import { Button } from "cxa-components";
import { reduxForm } from "redux-form";
import { Field, DateField, RadioButtons, StringField, DecimalField } from "cxa-form-field";
import { injectIntl, intlShape } from "react-intl";
import messages from "components/messagesDescription";

let pFields = [];

const required = intl => value =>
  value ? undefined : intl.formatMessage(messages.requiredDescription);

const validate = values => {
  const errors = {};
  pFields.forEach(f => {
    var value = values[f.id] == undefined ? '' : values[f.id].trim();
    if (f.required && !f.disabled && !value) {
      errors[f.id] = "Required";
    }
  });
  return errors;
};

const EditUserProfileForm = ({
  onSubmit,
  handleSubmit,
  pristine,
  submitting,
  fields,
  cancel,
  error,
  employeeKey,
  update,
  intl,
}) => {
  pFields = fields;

  let index = 0;
  return (
    <form onSubmit={handleSubmit(values => onSubmit(values, employeeKey, update, cancel))}>
      <article className="card">
        <section>
          {fields.map(item => {
            let field;
            const label = { label: item.displayName };
            if (item.type == "Date") {
              field = (
                <DateField
                  {...label}
                  name={item.id}
                  readOnly={item.disabled}
                  required={item.required}
                  dateFormat={item.formatter}
                />
              );
            } else if (item.type == "DropDown") {
              field = (
                <RadioButtons
                  {...label}
                  name={item.id}
                  items={item.dropdownValueList.map(item => ({
                    label: item.value,
                    value: item.id,
                  }))}
                  readOnly={item.disabled}
                  required={item.required}
                />
              );
            } else if (item.type == "Decimal") {
              field = (
                <DecimalField
                  {...label}
                  name={item.id}
                  readOnly={item.disabled}
                  required={item.required}
                />
              );
            } else if (item.type === "Boolean") {
              field = (
                <RadioButtons
                  {...label}
                  items={[
                    {
                      label: intl.formatMessage(messages.yesTextDescription),
                      value: "True",
                    },
                    {
                      label: intl.formatMessage(messages.noTextDescription),
                      value: "False",
                    },
                  ]}
                  name={item.id}
                  readOnly={item.disabled}
                  required={item.required}
                />
              );
            } else {
              field = (
                <StringField
                  {...label}
                  name={item.id}
                  {...item}
                  readOnly={item.disabled}
                  required={item.required}
                />
              );
            }
            return <div key={index++}>{field}</div>;
          })}
        </section>
      </article>
      {error && (
        <span style={{ color: "Red" }}>
          * {intl.formatMessage(messages.failedUpdateProfileDescription)}
        </span>
      )}
      <p>
        <Button primary type="submit" disabled={pristine || submitting}>
          {intl.formatMessage(messages.submitTextDescription)}
        </Button>
        <Button type="button" secondary onClick={cancel}>
          {intl.formatMessage(messages.cancelTextDescription)}
        </Button>
      </p>
    </form>
  );
};

EditUserProfileForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  pristine: PropTypes.bool,
  submitting: PropTypes.bool,
  fields: PropTypes.array,
  cancel: PropTypes.func,
  error: PropTypes.object,
  employeeKey: PropTypes.number,
  update: PropTypes.func,
  intl: intlShape.isRequired,
};

export default injectIntl(
  reduxForm({
    form: "editUserProfileForm",
    validate,
  })(EditUserProfileForm)
);



// WEBPACK FOOTER //
// ./components/employee/editUserProfile.jsx